"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _Text = require("../../../../Text");
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //lodash
//components
//styled-components
var ToolbarItemComponent = /*#__PURE__*/function (_Component) {
  function ToolbarItemComponent() {
    var _this;
    _classCallCheck(this, ToolbarItemComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ToolbarItemComponent, [].concat(args));
    _defineProperty(_this, "handleButtonClick", function () {
      var _this$props = _this.props,
        isDisabled = _this$props.isDisabled,
        iconId = _this$props.iconId;
      if (isDisabled) {
        return;
      }
      _this.propagateToggle({
        iconId: iconId
      });
    });
    _defineProperty(_this, "propagateToggle", function (_ref) {
      var iconId = _ref.iconId;
      (0, _invoke["default"])(_this.props, 'onToggle', {
        type: iconId
      });
    });
    return _this;
  }
  _inherits(ToolbarItemComponent, _Component);
  return _createClass(ToolbarItemComponent, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isActive = _this$props2.isActive,
        isDisabled = _this$props2.isDisabled,
        label = _this$props2.label,
        themeIconUrl = _this$props2.themeIconUrl,
        type = _this$props2.type,
        isWarning = _this$props2.isWarning,
        iconId = _this$props2.iconId;
      return /*#__PURE__*/_react["default"].createElement(_styles.ToolbarItem, {
        isActive: isActive,
        "data-cy": type
      }, /*#__PURE__*/_react["default"].createElement(_styles.ItemButton, {
        hasContent: !isDisabled,
        onClick: this.handleButtonClick,
        disabled: isDisabled,
        className: isActive ? 'active' : '',
        style: (0, _invoke["default"])(this.props, 'getToolbarButtonStyle', iconId),
        isWarning: isWarning
      }, /*#__PURE__*/_react["default"].createElement(_styles.IconAndTextWrapper, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'inline-hint-svg',
        dangerouslySetInnerHTML: {
          __html: themeIconUrl
        }
      }), label && /*#__PURE__*/_react["default"].createElement(_Text.TextDesktop, {
        tag: 'label',
        size: 'small'
      }, label))));
    }
  }]);
}(_react.Component);
_defineProperty(ToolbarItemComponent, "defaultProps", {
  isActive: false,
  isDisabled: false
});
_defineProperty(ToolbarItemComponent, "propTypes", {
  getToolbarButtonStyle: _propTypes["default"].func,
  iconName: _propTypes["default"].string,
  isActive: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  onToggle: _propTypes["default"].func,
  themeIconUrl: _propTypes["default"].string,
  type: _propTypes["default"].string
});
var _default = exports["default"] = ToolbarItemComponent;
//# sourceMappingURL=index.js.map